class LandingChallengeVideos extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.rail = this.querySelector('[data-video-rail], .landing-challenge-videos__rail');
    this.cards = [...this.querySelectorAll('[data-video-card], .landing-challenge-videos__card')];
    this.videos = this.cards.map((card) => card.querySelector('video'));
    const move = (direction) => {
      const card = this.cards[0];
      if (!card) return;
      const distance = card.clientWidth + parseFloat(getComputedStyle(this.rail).gap);
      this.rail.scrollBy({
        left: direction * distance,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    };
    this.querySelector('[data-previous]')?.addEventListener('click', () => move(-1), options);
    this.querySelector('[data-next]')?.addEventListener('click', () => move(1), options);
    this.rail.addEventListener(
      'keydown',
      (event) => {
        if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      },
      options
    );
    this.cards.forEach((card, index) => {
      const video = this.videos[index];
      const button = card.querySelector('[data-video-play], .landing-challenge-videos__play');
      button.addEventListener(
        'click',
        async () => {
          this.videos.forEach((other) => {
            if (other !== video) other.pause();
          });
          const source = video.querySelector('source');
          if (!source.src) {
            source.src = source.dataset.src;
            video.load();
          }
          if (video.hasAttribute('data-controls-on-play')) video.controls = true;
          button.hidden = true;
          try {
            await video.play();
          } catch {
            button.hidden = false;
          }
        },
        options
      );
      video.addEventListener(
        'play',
        () => {
          this.videos.forEach((other) => {
            if (other !== video) other.pause();
          });
          button.hidden = true;
        },
        options
      );
    });
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.25) entry.target.querySelector('video').pause();
        });
      },
      { threshold: [0, 0.25] }
    );
    this.cards.forEach((card) => this.observer.observe(card));
    this.addEventListener(
      'shopify:block:select',
      (event) => {
        const card = this.cards.find((card) => card.dataset.blockId === event.detail.blockId);
        if (card) this.rail.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant' });
      },
      options
    );
    const update = () => {
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      if (previous) previous.disabled = this.rail.scrollLeft <= 1;
      if (next) next.disabled = this.rail.scrollLeft >= this.rail.scrollWidth - this.rail.clientWidth - 1;
    };
    this.rail.addEventListener('scroll', update, options);
    this.resizeObserver = new ResizeObserver(update);
    this.resizeObserver.observe(this.rail);
    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) this.videos.forEach((video) => video.pause());
      },
      options
    );
    update();
  }
  disconnectedCallback() {
    this.videos?.forEach((video) => video.pause());
    this.controller?.abort();
    this.controller = null;
    this.observer?.disconnect();
    this.resizeObserver?.disconnect();
  }
}
if (!customElements.get('landing-challenge-videos'))
  customElements.define('landing-challenge-videos', LandingChallengeVideos);
